<template>
  <v-card class="d-flex align-items-center text-center mt-4">
    <div class="w-100">
      <v-card-title class="card-title">
        Acceso al sistema
      </v-card-title>
      <v-card-text class="text-left px-6 pb-6">
        <div class="d-flex align-center flex-wrap">
          <v-chip small :color="status.color" :text-color="status.text_color" class="mr-3">{{ status.name }}</v-chip>
          <span v-if="legajo.access">
            Usuario: <b>{{ legajo.access.email }}</b>
            <span v-if="legajo.access.last_login" class="grey--text"> · Último ingreso {{ formatDateTime(legajo.access.last_login) }}</span>
          </span>
          <span v-else class="grey--text">El empleado todavía no puede entrar al sistema para ver y firmar sus recibos.</span>
        </div>
        <p v-if="!legajo.access" class="grey--text mt-3 mb-0">
          El acceso se crea automáticamente al guardar el legajo con un email: el usuario es el email y la contraseña inicial
          es su número de documento (la cambia en el primer ingreso). Si no se pudo crear (por ejemplo, el email ya está en
          uso), puede crearlo a mano.
        </p>

        <div class="mt-4">
          <v-btn v-if="!legajo.access" small color="primary" :disabled="!legajo.email || !!legajo.finish_date"
            @click="openPassword(false)">Crear acceso</v-btn>
          <template v-else>
            <v-btn small outlined color="primary" class="mr-2" @click="openPassword(true)">Blanquear contraseña</v-btn>
            <v-btn v-if="legajo.access.enable" small outlined color="red" :loading="loading" @click="setEnabled(false)">Deshabilitar acceso</v-btn>
            <v-btn v-else small outlined color="green" :loading="loading" :disabled="!!legajo.finish_date" @click="setEnabled(true)">Habilitar acceso</v-btn>
          </template>
        </div>
      </v-card-text>
    </div>

    <ModalAccessPassword :dialog="dialog_password" :legajo="legajo" :reset="reset_password"
      @updateDialog="(value) => (dialog_password = value)" @saved="onSaved" />
  </v-card>
</template>

<script>
import { legajoService } from "@/libs/ws/legajoService";
import { formatDateTime } from "@/constants/payslips";
import ModalAccessPassword from "./ModalAccessPassword.vue";

// Acceso del empleado: usuario = email del legajo, contraseña temporal que cambia en el primer ingreso
export default {
  components: { ModalAccessPassword },
  name: "CardAccess",
  props: {
    legajo: Object,
  },
  data() {
    return {
      dialog_password: false,
      reset_password: false,
      loading: false,
      formatDateTime: formatDateTime,
    };
  },
  computed: {
    status() {
      const access = this.legajo.access;
      if (!access) return { name: "Sin acceso", color: "grey lighten-3", text_color: "grey darken-3" };
      if (!access.enable) return { name: "Deshabilitado", color: "red lighten-4", text_color: "red darken-3" };
      if (access.must_change_password) return { name: "Pendiente de primer ingreso", color: "orange lighten-4", text_color: "orange darken-4" };
      return { name: "Activo", color: "green lighten-4", text_color: "green darken-3" };
    },
  },
  methods: {
    openPassword(reset) {
      this.reset_password = reset;
      this.dialog_password = true;
    },
    onSaved(legajo) {
      this.legajo.access = legajo.access;
    },
    setEnabled(enable) {
      this.loading = true;
      (enable ? legajoService.enable_access : legajoService.disable_access)({ id: this.legajo.id })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.legajo.access = response.result.access;
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
  },
};
</script>
